import React, { useState, useEffect, useMemo, memo } from "react";
import {
  UncontrolledTooltip,
  Input,
  Card,
  CardBody,
  Media,
  Spinner,
  Collapse,
  Popover,
  PopoverHeader,
  PopoverBody,
} from "reactstrap";

import "./ScriptsContent.scss";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

// actions
import { getScripts } from "../../../../../store/script/actions";
// actions
import {
  getScript,
  favoritedScriptResetError,
} from "../../../../../store/favoriteScripts/actions";

import FavoriteScript from "./FavoriteScript/FavoriteScript";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const ScriptsContent = ({ skillId, onClick, t }) => {
  const dispatch = useDispatch();

  const { favorites, status, errorFavoriteScript } = useSelector(
    (state) => state.FavoriteScripts
  );
  const [popovers, setPopovers] = useState({});

  const togglePopover = (id) => {
    id = id.toString();
    setPopovers((prev) => ({
      ...prev,
      [id]: !popovers[id],
    }));
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () => status.success && dispatch(favoritedScriptResetError()),
  };

  const { dataScript, loadingDataScript } = useSelector(
    (state) => state.Script
  );
  const mainTheme = useSelector((state) => state.Layout.mainTheme);

  const [msgs, setMsgs] = useState();
  const [collapse, setCollapse] = useState([]);
  const categories = [];

  const toggle = (key) => {
    let aux = [...collapse];
    aux[key] = !aux[key];
    setCollapse(aux);
  };

  const handleFavoriteScript = () => {
    dispatch(getScript());
  };
  useEffect(() => {
    handleFavoriteScript();
  }, []);

  useEffect(() => {
    if (errorFavoriteScript && typeof errorFavoriteScript === "object") {
      errorFavoriteScript.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value !== "Script not found" &&
          showToast("error", t(error.value))
      );
      dispatch(favoritedScriptResetError());
    } else {
      if (errorFavoriteScript) {
        showToast("error", t(errorFavoriteScript));
        dispatch(favoritedScriptResetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorFavoriteScript]);

  const checkName = (name) => {
    return name === "Geral" || name === "General";
  };

  const renderFavorites = (data) => {
    let key = data.length + 1;

    return (
      <div key={key} className={`item ${collapse[key] && "item-opened"}`}>
        <div
          className="text-wrap pointer d-flex py-3"
          onClick={() => {
            toggle(key);
          }}
        >
          <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon"></i>
          <div className="d-flex flex-column w-100 ml-2 pl-1">
            <div className="d-flex justify-content-between my-auto">
              <div className="d-inline-flex order-1 title">
                {t("Favorites")}
              </div>
            </div>
          </div>
        </div>

        <Collapse className="mx-1 my-0 " isOpen={collapse[key]}>
          {data.map((script, subkey) =>
            favorites?.includes(script.id) && script.activated === true ? (
              <Card
                className="mt-2 pointer"
                key={`${subkey}${key}`}
                style={{
                  background: mainTheme === "dark" ? "#262B3C" : "#F1F0F0",
                }}
              >
                <CardBody
                  className="p-0 d-flex align-items-center "
                  onMouseEnter={() => togglePopover(`${subkey}${key}`)}
                  onMouseLeave={() => togglePopover(`${subkey}${key}`)}
                >
                  <Media
                    body
                    className="p-3 text-scripts-card"
                    id={`msgBodyScript${subkey}${key}`}
                  >
                    <div className="text-muted font-weight-bold max-lines-quick text-truncate">
                      {script.title}
                    </div>
                    <p className="mb-0 max-lines-quick text-truncate font-color-predefined-msgsfont-weight-light">
                      {script.text}
                    </p>
                  </Media>
                  {script?.files && (
                    <div
                      className="file-icon"
                      onClick={() => {
                        window.open(script.files);
                      }}
                    >
                      <i className="bx bx-file-blank" />
                    </div>
                  )}
                  { document.querySelector(`#msgBodyScript${subkey}${key}`) && (
                    <PopoverContainer
                      id={`${subkey}${key}`}
                      message={script.text}
                      title={script.title}
                      isOpen={popovers}
                    />
                  )}
                  <FavoriteScript
                    msgId={script.id}
                    enableClick={false}
                    order={"order-1"}
                    favoritos={favorites}
                  />
                </CardBody>
              </Card>
            ) : (
              <div></div>
            )
          )}
        </Collapse>
      </div>
    );
  };

  const renderScripts = (data) => {
    data?.forEach((element) => {
      if (element.activated) {
        if (!element?.categories?.length) {
          const pos = categories.findIndex((e) => checkName(e.name));
          if (pos > -1) {
            categories[pos].messages.push(element.text);
            categories[pos].title.push(element.title);
            categories[pos].id.push(element.id);
            categories[pos].files.push(element.files);
          } else {
            categories.push({
              name: t("General"),
              messages: [element.text],
              title: [element.title],
              id: [element.id],
              files: [element.files],
            });
          }
        }
        element?.categories?.forEach((category) => {
          const pos = categories.findIndex((e) => e.name === category);

          if (pos > -1) {
            categories[pos].messages.push(element.text);
            categories[pos].title.push(element.title);
            categories[pos].id.push(element.id);
            categories[pos].files.push(element.files);
          } else {
            categories.push({
              name: category,
              messages: [element.text],
              title: [element.title],
              id: [element.id],
              files: [element?.files],
            });
          }
        });
      }
    });

    return categories?.map((category, key) =>
      data && data[key]?.parent === undefined ? (
        <div key={key} className={`item ${collapse[key] && "item-opened"}`}>
          <div
            className="text-wrap pointer d-flex py-3"
            onClick={() => {
              toggle(key);
            }}
          >
            <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon"></i>
            <div className="d-flex flex-column w-100 ml-2 pl-1">
              <div className="d-flex justify-content-between my-auto">
                <div className="d-inline-flex order-1 title">
                  {category.name}
                </div>
              </div>
            </div>
          </div>

          <Collapse className="mx-1 my-0 " isOpen={collapse[key]}>
            {category.messages.map((message, subkey) => (
              <Card
                className="mt-2 pointer"
                key={`${subkey}${key}`}
                style={{
                  background: mainTheme === "dark" ? "#262B3C" : "#F1F0F0",
                }}
              >
                <CardBody
                  className="p-0 d-flex align-items-center"
                  onMouseEnter={() => togglePopover(`category${subkey}${key}`)}
                  onMouseLeave={() => togglePopover(`category${subkey}${key}`)}
                >
                  <Media
                    body
                    className="p-3 text-scripts-card"
                    id={`msgBodyScriptcategory${subkey}${key}`}
                  >
                    <div className="text-muted font-weight-bold max-lines-quick text-truncate">
                      {category.title[subkey]}
                    </div>
                    <p className="mb-0 max-lines-quick text-truncate font-color-predefined-msgsfont-weight-light">
                      {message}
                    </p>
                  </Media>
                  {category?.files[subkey] && (
                    <div
                      className="file-icon"
                      onClick={() => {
                        window.open(category.files[subkey]);
                      }}
                    >
                      <i className="bx bx-file-blank" />
                    </div>
                  )}
                  <PopoverContainer
                    id={`category${subkey}${key}`}
                    message={message}
                    title={category.title[subkey]}
                    isOpen={popovers}
                  />
                  <FavoriteScript
                    msgId={category.id[subkey]}
                    enableClick={false}
                    order={"order-1"}
                    favoritos={favorites}
                  />
                </CardBody>
              </Card>
            ))}
          </Collapse>
        </div>
      ) : (
        category.name
          .toUpperCase()
          .includes(data[key].parent.toUpperCase()) && (
          <div key={key} className={`item ${collapse[key] && "item-opened"}`}>
            <div
              className="text-wrap pointer d-flex py-3"
              onClick={() => {
                toggle(key);
              }}
            >
              <i className="bx bx bxs-chevron-right color2 font-size-15 list-icon"></i>
              <div className="d-flex flex-column w-100 ml-2 pl-1">
                <div className="d-flex justify-content-between my-auto">
                  <div className="d-inline-flex order-1 title">
                    {category.name}
                  </div>
                </div>
              </div>
            </div>

            <Collapse className="mx-1 my-0 " isOpen={collapse[key]}>
              {category.messages.map((message, subkey) => (
                <Card
                  className="mt-2 pointer"
                  key={`${subkey}${key}`}
                  style={{
                    background: mainTheme === "dark" ? "#262B3C" : "#F1F0F0",
                  }}
                >
                  <CardBody
                    onClick={() =>
                      onClick({
                        message: message,
                        file: category?.files[subkey],
                      })
                    }
                    className="p-0 "
                    onMouseEnter={() => togglePopover(`category2${subkey}${key}`)}
                    onMouseLeave={() => togglePopover(`category2${subkey}${key}`)}
                  >
                    <Media
                      body
                      className="p-3"
                      id={`msgBodyScriptcategory2${subkey}${key}`}
                    >
                      <div className="text-muted font-weight-bold">
                        {category.title[subkey]}
                      </div>
                      <p className="mb-0 text-truncate font-color-predefined-msgsfont-weight-light">
                        {message}
                      </p>
                    </Media>
                    <PopoverContainer
                      id={`category2${subkey}${key}`}
                      message={message}
                      isOpen={popovers}
                    />
                  </CardBody>
                </Card>
              ))}
            </Collapse>
          </div>
        )
      )
    );
  };

  useEffect(() => {
    skillId && dispatch(getScripts(undefined, undefined, undefined, skillId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skillId]);

  useEffect(() => {
    setMsgs(dataScript && dataScript.scripts);
  }, [dataScript]);

  return (
    <div className="client-info-card">
      <div className="search-box chat-search-box mb-4">
        <Input
          id="search"
          type="text"
          className="form-control SearchPreDefinedMsgs"
          placeholder={t("Search")}
          autoComplete="off"
          onInput={(e) => {
            setMsgs(
              dataScript &&
                dataScript.scripts.filter((msg) => {
                  // This replace is to skip any special Char, in order to not give an error
                  const res = new RegExp(
                    e.target.value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"),
                    "gi"
                  );
                  // Check if category names match input from search
                  if (
                    msg?.categories?.length &&
                    msg.categories.some((category) => category.match(res))
                  ) {
                    msg.parent = e.target.value;
                    return msg;
                  }

                  // Check if category is null, so predefined is general or geral according to a regex.
                  if (
                    msg?.categories === null &&
                    ("GENERAL".includes(e.target.value.toUpperCase()) ||
                      "GERAL".includes(e.target.value.toUpperCase()))
                  ) {
                    return msg;
                  }

                  // Check if message text match input from search input
                  return msg.text.match(res) || msg.title.match(res);
                })
            );
          }}
        />
        <i className="bx bx-search-alt search-icon"></i>
      </div>
      {loadingDataScript ? (
        <div className="h-100 text-center pt-4">
          <Spinner animation="border" size="sm" className="spinner" />
        </div>
      ) : (
        Array.isArray(msgs) && msgs.length > 0 && renderFavorites(msgs)
      )}
      {loadingDataScript ? (
        <div className="h-100 text-center pt-4">
          <Spinner animation="border" size="sm" className="spinner" />
        </div>
      ) : Array.isArray(msgs) && msgs.length > 0 ? (
        renderScripts(msgs)
      ) : (
        <div className="text-center mb-3">{t("No matching records found")}</div>
      )}
    </div>
  );
};
export default withTranslation()(memo(ScriptsContent));

const PopoverContainer = ({ id, title, message, isOpen }) => {
  return (
    <Popover
      target={`msgBodyScript${id}`}
      isOpen={isOpen?.[id?.toString()]}
      placement="bottom" 
    >
      {title && <PopoverHeader>{title}</PopoverHeader>}
      <PopoverBody className={`d-inline-block skills-tooltip`}>
        <div className="font-color-predefined-msgs">{message}</div>
      </PopoverBody>
    </Popover>
  );
};
